import './app-info.scss';
function AppInfo({ employees, data }) {
    const rise = data.filter((item) => item.increase).length;
    return (
        <div className="app-info">
            <h1>Учет сотрудников в компании Shmidt Inc</h1>
            <h2>Общее число сотрудников: {employees} </h2>
            <h2>Премию получат: {rise} </h2>
        </div>
    );
}
export default AppInfo;